export default "__VITE_ASSET__CxOYnqzA__"